import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { createMaintenanceService } from '../../api/maintenance-service.ts';
import { CreateMaintenanceServiceRequest } from '../../api/requests/maintenance-service-request.ts';

export default function useCreateMaintenanceService(): UseMutationResult<
  Awaited<ReturnType<typeof createMaintenanceService>>,
  Error,
  CreateMaintenanceServiceRequest
> {
  return useMutation({
    mutationFn: createMaintenanceService,
  });
}
